function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import { Stack } from 'office-ui-fabric-react';
import { DefaultButton } from '../Button/Default';
import { PrimaryButton } from '../Button/Primary';
import { ActionModal } from './ActionModal';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export const ConfirmationModal = props => {
  const Footer = /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(DefaultButton, {
      onClick: props.onDismiss,
      style: {
        marginRight: '8px'
      },
      "data-id": "ModalCancelButton",
      children: "Cancel"
    }), /*#__PURE__*/_jsx(PrimaryButton, {
      onClick: props.onConfirmClick,
      disabled: false,
      "data-id": "ModalConfirmButton",
      children: "Confirm"
    })]
  });
  return /*#__PURE__*/_jsx(ActionModal, _objectSpread(_objectSpread({}, props), {}, {
    headerTitle: props.headerTitle,
    footer: Footer,
    dataId: 'ConfirmationModal',
    children: /*#__PURE__*/_jsx(Stack, {
      styles: {
        root: {
          marginBottom: 40
        }
      },
      children: props.subText
    })
  }));
};
ConfirmationModal.defaultProps = {
  headerTitle: 'Are you sure?'
};